import React from 'react'
import VideoJS from './video'
import VideoJS06 from './video06'
import './assets/styles.scss'
import connect from "~/tools/connect";
import userStore from '~/redux/user/store';

class VideoJSPlayer extends React.Component {
	disableRightClick(e){
		// e.preventDefault()
	}

	render() {
		return (
			<div className="VideoJS" onContextMenu={this.disableRightClick.bind(this)}>
				{(this.props.layout === "AC VideoPlayerWithInfo 06" || this.props.layout === "AC VideoPlayerWithInfo 07") ? <VideoJS06 {...this.props} user={this.state.user} /> : <VideoJS {...this.props} user={this.state.user} />}
			</div>
		)
	}
}

connect(VideoJSPlayer, state => ({ user: state.user }), userStore)

export default VideoJSPlayer
		